import React from 'react';
import jss from 'jss';
import preset from 'jss-preset-default';

import theme from 'utils/theme';

jss.setup(preset());

const styles = ({ cursor, fontSize, fontWeight, lineHeight, padding, textAlign, width }) => ({
    btnWrapper: {
        background: `${theme.colors.black}`,
        color: `${theme.colors.white}`,
        cursor: cursor || 'pointer',
        fontFamily: 'CircularStd',
        fontSize: fontSize || '14px',
        fontWeight: fontWeight || '500',
        lineHeight: lineHeight || '18px',
        padding: padding || '16px',
        textAlign: textAlign || 'center',
        textTransform: 'uppercase',
        width: width || 'initial',
        zIndex: '100',
        border: 0,

        '&[disabled]': {
            background: `${theme.colors.white}`,
            color: `${theme.colors.grey300}`,
            border: `1px solid ${theme.colors.grey300}`,
            cursor: 'default'
        }
    },
});

export default function Button({ className, children, customStyles, disabled, onClick }) {
    const { classes } = jss.createStyleSheet(styles({ ...customStyles })).attach();

    return (
        <button className={classes.btnWrapper} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
}
